import React, { Component, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Typo from '../../components/CustomTypo';
import { Grid } from '@material-ui/core';
import { ErrorIcon, SuccessIcon } from '../../components/icons'
import Container from '../../components/Container';
import ModalAlert from '../../components/ModalAlert';
import Cookies from 'js-cookie';
import { connection } from '../../../portal.config';
import crmservices from '../../wsclient/';
import ButtonCustom from '../../components/ButtonCustom';
import { paths } from '../../../portal.router.config';

function FACResult(props) {
    const { classes, t } = props;

    const [showLoading, onShowLoading] = useState(true);
    const [message, setMessage] = useState({});
    const [ready, setReady] = useState(true);
    const [payload, setPayload] = useState(null);
    const [facResult, setFACResult] = useState(null);

    useEffect(() => {
        onLoad();
    },[]);

    const onLoad = async () => {
        var url = new URL(window.location.href);
        console.log("url===", url);
        var clientTokenId = url.searchParams.get("ID");
        var respCode = url.searchParams.get("RespCode");
        var reasonCode = url.searchParams.get("ReasonCode");

        let payload = {
            nonce: clientTokenId,
            name: 'FAC',
            respCode: respCode,
            reasonCode: reasonCode,
        };
        setPayload(payload);

        if(respCode == '1' && reasonCode == '1'){
            setReady(true);
            await onAddPaymentMethod(payload);
        }else{
            setReady(true);
            setFACResult('error');
        }
        onShowLoading(false);
    }
    const showMessage = async (status, message) => {
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        });
    }

	const onAddPaymentMethod = async (payload) => {
		console.log("payload:", payload);
		let facIntegration = connection.crmConfig.facIntegration;
		let createCustomerResult = await crmservices.paymentgateway.addPaymentMethod({
			name: payload.name,
			integration_id: facIntegration,
			payment_method_nonce_token: payload.nonce,
            payment_method_type: "CARD",
            // gateway: 'JCC'
		});
		console.log('createCustomerResult ===', createCustomerResult)
		if (createCustomerResult.code === 'OK') {			
            setFACResult('success');
		}
		else if (createCustomerResult.code === 'CUSTOMER_EMAIL_ALREADY_EXIST') {
			showMessage(true, t('CUSTOMER_EMAIL_ALREADY_EXIST'))
            setFACResult('error');
		}
		else {
			showMessage(true, t('EXCEPTION_PROCESS'))
            setFACResult('error');
		}
	}

    if (ready)
        return (
            <Container showLoading={showLoading}>
                <Grid xs={12} item>
                    <Grid xs={12} item justify='center' container>
                       {facResult == 'success' && <SuccessIcon style={{ width: 100, height: 100 }} />} 
                       {facResult == 'error' && <ErrorIcon style={{ width: 100, height: 100 }} />} 
                    </Grid>
                    <Grid xs={12} item justify='center' container>
                        {facResult == 'success' && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t("Add payment method successfully")}</Typo>}
                        {facResult == 'error' && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t('Add payment method failed')}</Typo>}
                        
                    </Grid>
                    <Grid item xs={12} justify='center' container style={{marginTop: 20}}>
                        <ButtonCustom  onClick={() => props.history.push(paths.home)} color="primary">{"Back to Home"}</ButtonCustom>
                    </Grid>
                </Grid>
                {message && <ModalAlert
                    open={message.show}
                    onClose={showMessage}
                    message={message.content}
                />}
            </Container >
        );
    else {
        return (
            <Container showLoading={showLoading}>

            </Container>
        )
    }
}

const styles = theme => ({
    boxItemContent: {
        padding: theme.spacing(5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: theme.boxShadow.primary,
        cursor: 'pointer',
    },
});
export default withStyles(styles)(withTranslation()(FACResult));